<template>
  <div>
    <div class="technology-block">
      <div class="technology-title">
        {{ $t('technology.title') }}
      </div>
      <div class="technology-subtitle">
        {{ $t('technology.subtitle') }}
      </div>
    </div>
    <carousel
      class="technology-carousel"
      :per-page="3"
      :mouse-drag="true"
      :loop="true"
      :autoplayTimeout="4000"
      autoplay
      :perPageCustom="[[320, 1], [730, 2], [1199, 4], [2160, 6]]"
    >
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/cisco.png" height="80px" class="grayscale" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/gitlab.png" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/cumulus.png" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/keycloak.png" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/kubernetes.png" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/ansible.png" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/jenkins.png" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/jovian.jpg" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/cloudstack.png" height="80px" />
        </div>
      </slide>
      <slide>
        <div class="text-center techno-img">
          <b-img src="../assets/software/kvm.png" height="80px" />
        </div>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  components: {
    Carousel,
    Slide
  },
   data() {
    return {
    }
   }
  
};
</script>
